import { LoadingState } from "@material-dev/insights-portal-ui-components/lib/types";
import { RelevancyCheckerStatuses, TextVariableDto } from "app/ApiClient";

export type RelevancyCheckerVariable = {
  variableName?: string;
  token?: string;
  status?: RelevancyCheckerStatuses;
};

export type RelevancyCheckerInitiateTokens = {
  projectId?: number;
  variables?: RelevancyCheckerVariable[];
};

export type RelevancyCheckerDownloadToken = {
  projectId: number;
  token: string;
};

export type RelevancyCheckerVariableOrBatteryName = {
  projectId: number;
  name?: string;
};

export interface RelevancyCheckerState {
  errorMessage?: string;
  downloadRelevancyCheckerErrorMessage?: string;
  initiateRelevancyCheckerStatus: LoadingState;
  RelevancyCheckerVariables: TextVariableDto[];
  relevancyCheckerInitiateTokens?: RelevancyCheckerInitiateTokens[];
  relevancyDownloadingState: LoadingState;
  relevancyCheckerDownloadTokens: RelevancyCheckerDownloadToken[];
  resultMessageVariable:RelevancyCheckerVariableOrBatteryName[];
  errorMessageVariable:RelevancyCheckerVariableOrBatteryName[];
  presignedUrl: string | null;
}

export const initialRelevancyChecker: RelevancyCheckerState = {
  RelevancyCheckerVariables: [],
  initiateRelevancyCheckerStatus: LoadingState.idle,
  relevancyCheckerInitiateTokens: [],
  relevancyDownloadingState: LoadingState.idle,
  relevancyCheckerDownloadTokens: [],
  resultMessageVariable: [],
  errorMessageVariable: [],
  presignedUrl:null
};
